export const cn = {
    QuickSave: {
        save: '保存',
        quickSave: '快速保存',
        saved: '已保存',
    },
    BatchSave: '批量保存',
    SaveToWorkspace: {
        saveTip: '保存至',
        messageBefore: '专利正在添加， 请到',
        toWorkspace: '工作空间“{folderName}”',
        messageAfter: '查看',
    },
}

export const en = {
    QuickSave: {
        save: 'Save',
        quickSave: 'Quick save',
        saved: 'Saved',
    },
    BatchSave: 'Batch Save',
    SaveToWorkspace: {
        saveTip: 'Save to',
        messageBefore: 'Patents are being added,  please go to ',
        toWorkspace: 'workspace "{folderName}" ',
        messageAfter: 'to view the results',
    },
}

export const jp = {
    QuickSave: {
        save: 'Save',
        quickSave: 'Quick save',
        saved: 'Saved',
    },
    BatchSave: '一括保存',
    SaveToWorkspace: {
        saveTip: 'Save to',
        messageBefore: 'Patents are being added,  please go to ',
        toWorkspace: 'workspace "{folderName}" ',
        messageAfter: 'to view the results',
    },
}

export const tw = {
    QuickSave: {
        save: '保存',
        quickSave: '快速保存',
        saved: '已保存',
    },
    BatchSave: '批量保存',
    SaveToWorkspace: {
        saveTip: '保存至',
        messageBefore: '專利正在添加， 請到',
        toWorkspace: '工作空間“{folderName}”',
        messageAfter: '查看',
    },
}
